export default "__VITE_ASSET__ee0b0df5__"